
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class MinimalistLinesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, width, height } = pc;
         const spacing = (100 + layerIndex * 50) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing );
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = (1 + layerIndex) * scale;

        const draw = () => {
            for (let x = x1; x <= x2; x += spacing) {
                const h = height * 0.4 * scale * (this.pseudoRandom(x) + 0.5);
                ctx.beginPath();
                ctx.moveTo(x, -h);
                ctx.lineTo(x, h);
                ctx.stroke();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
